// @flow
/**
 * This page is used to perform Slack authentication and redirect to the right domain
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { sessionOperations } from "state/ducks/session";
import * as sessionTypes from "state/ducks/session/types";
import { uiOperations } from "state/ducks/ui";

// Components
import { Link } from "react-router-dom";
import Loader from "v2/components/Loader";

const Container = styled.main`
  display: flex;
  justify-content: center;
  margin: 10vh 0 0 0;
  ion-icon {
    font-size: 2.2rem;
    padding-right: 0.8rem;
  }
`;

type Props = {
  clearPage: Function,
  slackAuth: Function,
  ui: Object,
  location: Object
};

type State = {};

class GoogleLogin extends Component<Props, State> {
  componentDidMount() {
    const { location } = this.props;
    this.props.clearPage();
    // get the params from the URL

    if (location && location.search) {
      const params = new URLSearchParams(location.search);

      const code = params.get("code");
      const state = params.get("state");

      const stateDecoded = state ? JSON.parse(atob(state)) : null;

      if (stateDecoded) {
        const slackAuthParams = {
          code,
          state
        };

        // Then post the auth request to the backend
        this.props.slackAuth(slackAuthParams).then(action => {
          if (action.type === sessionTypes.SLACK_AUTH_COMPLETED) {
            window.location.href = `https://${stateDecoded.domain}`;
          }
        });
      }
    }

    // If the action is successful, redirect to the domain param
  }

  render() {
    const { ui } = this.props;
    return (
      <Container>
        {!ui.isFetching && !ui.error && <div>Redirecting you.</div>}

        {!ui.isFetching && ui.error && (
          <div>
            <p>Sorry, we could not log you in.</p>
            <p>
              <Link to="/">Go back to login</Link>
            </p>
          </div>
        )}
        {ui.isFetching && <Loader />}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.session.isAuthenticated,
  ui: state.ui.slackAuth
});

const mapDispatchToProps = {
  clearPage: uiOperations.clearPage,
  slackAuth: sessionOperations.slackAuth
};

export default connect(mapStateToProps, mapDispatchToProps)(GoogleLogin);
